import Header from "../components/Header"
import CartForm from "../components/CartForm" // Assure-toi que ce fichier existe
import Footer from "../components/Footer"
   

function Cart() {
  return (
    <>
      <Header/>
      <CartForm />
      <Footer />
    </>
  )
}

export default Cart
